import React from "react";
import { useAsyncDebounce } from "react-table";

function ColumnFilter({ column }) {
  const { filterValue, setFilter } = column;

  const onChange = useAsyncDebounce((value) => {
    setFilter(value || undefined);
  }, 400);

  return (
    <span>
      Search:{" "}
      <input
        value={filterValue || ""}
        onClick={(e) => {
          e.stopPropagation();
        }}
        onChange={(e) => {
          setFilter(e.target.value);
          onChange(e.target.value);
        }}
      />
    </span>
  );
}

export default ColumnFilter;
